import React from 'react';
import {Box, Skeleton, ListItem, ListItemAvatar, ListItemText} from '@mui/material';

const CommentSkeleton = () => {
  return (
    <ListItem >
      <ListItemAvatar>
        <Skeleton variant='circular' width={40} height={40}/>
      </ListItemAvatar>
      <ListItemText
        primary={
          <>
            <Skeleton/>
            <Box sx={classes.caption} color='textPrimary'>
              <Skeleton/>
            </Box>
          </>
        }
        secondary={
          <React.Fragment>
            <Skeleton/>
            <Skeleton/>
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

const classes = {
  caption: {
    display: 'inline',
    opacity: 0.5,
    fontSize: '.7em',
    fontStyle: 'italic'
  }
};

CommentSkeleton.propTypes = {};

CommentSkeleton.defaultProps = {};

export default CommentSkeleton;
